import { render, staticRenderFns } from "./AdminExtension.vue?vue&type=template&id=70d6fa6a"
import script from "./AdminExtension.vue?vue&type=script&lang=js"
export * from "./AdminExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d6fa6a')) {
      api.createRecord('70d6fa6a', component.options)
    } else {
      api.reload('70d6fa6a', component.options)
    }
    module.hot.accept("./AdminExtension.vue?vue&type=template&id=70d6fa6a", function () {
      api.rerender('70d6fa6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminExtension.vue"
export default component.exports